import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ScrollToTopProps } from './ScrollToTop.interface';

export default function ScrollToTop(props: ScrollToTopProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
